var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskRescueService = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.128 20.236c0 1.344-.45 2.26-1.265 2.641-.866.253-1.621.043-1.907.012-.808-.356-1.972-1.932-.146-3.379.66-.55 1.4-1.168 1.502-3.066.607.548 1.816 1.88 1.816 3.791M9.855 1c1.793 3.645.665 5.6.665 5.6s-1.397-.926-1.93-1.168c.426 1.98.172 4.512-1.387 5.524-6.27 4.851-1.324 9.816.67 10.945-.676-.831-2.586-3.937 1.26-6.386 3.944-2.535 1.622-5.693 1.622-5.693s3.125-.533 5.972 5.532a7.48 7.48 0 0 1-.623 6.373c2.404-1.58 3.766-4.486 3.766-7.382C19.87 5.955 11.41 1.014 9.855 1"
})));
export default SvgTaskRescueService;